import { useState } from "react";
import { usePlane } from "@react-three/cannon";
import { useLoader } from "@react-three/fiber";
import { TextureLoader, RepeatWrapping } from 'three';
import Coin from "./Coin";

function Ground() {
    const [ref] = usePlane(() => ({
        rotation: [-Math.PI / 2, 0, 0],
        position: [0, 0, 0],
    }));

    return (
        <group>
            <mesh receiveShadow rotation-x={-Math.PI / 2}>
                <meshBasicMaterial color="mediumOrchid" />
                <circleGeometry args={[3.5, 64]} />
            </mesh>
        </group>
    )
}



export default function Scene({ onResult, coinColor, headsType, tailsType }) {

    return (
        <>
            <ambientLight intensity={0.4} />
            <directionalLight
                position={[5, 10, 5]}
                castShadow
                intensity={2}
                shadow-mapSize-width={2048}
                shadow-mapSize-height={2048}
            />
            <Ground />
            <Coin
                onResult={onResult}
                color={coinColor}
                headsType={headsType}
                tailsType={tailsType}
            />
        </>
    );
}
